import UserItem from './UserItem.view';
export * from './UserComp';

export default UserItem;
